import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { lazy } from 'react'

const DonationPortalPageContainer = lazy(
  () => import('./DonationPortalPageContainer/DonationPortalPageContainer')
)

const DonationPortalEditContainer = lazy(
  () => import('./DonationPortalEditContainer/DonationPortalEditContainer')
)

export default {
  path: '/account',
  exact: false,
  Component: WithPermission(
    DonationPortalPageContainer,
    ['page:fundraising:donations'],
    true
  ),
  access: 'USER',
  routes: [
    {
      path: `/account/donation/portal/:portalId?`,
      exact: true,
      Component: DonationPortalEditContainer,
      access: 'User',
    },
  ],
}
